/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import { cloneDeep, sortBy } from "lodash";
import { GeneralSection } from "../../general/index"

/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions */

function handleInitialAdjustments({
  questionnaire,
  setTaxes,
  periods,
  insurerGroup,
  isRefresh = false,
  questionnaireAux
}) {
  if (periods.length > 0 && insurerGroup?.length || isRefresh) {
    // criando grupos de questions de acordo com seção taxes
    let groupQuestion = GeneralSection.events.groupMultipleFieldQuestions({
      mainIdQuestion: 2426,
      handleQuestionsInitialAdjustments: null,
      questionnaire: cloneDeep(questionnaireAux) || questionnaire,
    })

    let hasTax = false;
    for (const group of groupQuestion) {
      if (group[0] && group[0].answer != null && group[0].answer !== '') {
        hasTax = true;
        break;
      }
    }

    const taxesObject = mountTaxesObjects({ insurerGroup, periods });
    if (!hasTax || isRefresh) {
      const groupedQuestionByTax = createQuestionsByTax({ taxesObject, groupQuestion })
      setTaxes([]);
      setTimeout(() => setTaxes(groupedQuestionByTax), 300)
    } else {
      const groupedQuestionByTax = groupTaxesQuestions({ groupQuestion, taxesObject });
      setTaxes([]);
      setTimeout(() => setTaxes(groupedQuestionByTax), 300)
    }
  }

  return questionnaire.map(question => {
    return question;
  })
};

async function handleQuestionChange({
  question,
  value,
  questionnaireUpdated,
  setFieldValue,
  tax,
  setTaxes,
  indexQuestions,
}) {
  try {

    if ([2429, 2430, 2431].includes(question.idQuestion)) {
      const { idQuestion } = question;

      const questions = tax.groupedQuestions[indexQuestions];

      const updatedQuestions = questions.map((q) => {
        if (q.idQuestion === idQuestion) {
          q.answer = value;
          q.answerJson = value;
          setFieldValue(q.key, value);
        }
        return q;
      });

      setTaxes((prevTaxes) => prevTaxes.map((t) => {
        if (t.taxType === tax.taxType) {
          t.groupedQuestions[indexQuestions] = updatedQuestions;
          return t;
        }
        return t
      }))

    }
  } catch (e) {
    console.log('TAX_CALCULATION - handleQuestionChange - error', e)
  }
};

function handleQuestionBlur({
  question,
  value,
  questionnaireUpdated,
  setFieldValue,
  tax,
  indexQuestions,
  setTaxes,
}) {
  if ([2429, 2430, 2431, 2432, 2433].includes(question.idQuestion)) {
    const { dpBasis, apBasis, apTax, dpTax, totalTax } = recalculateTax({
      idQuestion: question.idQuestion,
      tax,
      indexQuestions,
      value,
    });

    const questions = tax.groupedQuestions[indexQuestions];
    const valueMap = new Map([
      [2429, dpBasis],
      [2430, apBasis],
      [2432, dpTax],
      [2433, apTax],
      [2438, totalTax],
    ]);

    questions.forEach((q) => {
      if (valueMap.has(q.idQuestion)) {
        q.answer = valueMap.get(q.idQuestion);
        q.answerJson = valueMap.get(q.idQuestion);
        setFieldValue(q.key, String(valueMap.get(q.idQuestion)));
      }
    });

    tax.dpTaxGrandTotal = recalculateTotal({ idQuestion: 2432, tax }).toFixed(2);
    tax.apTaxGrandTotal = recalculateTotal({ idQuestion: 2433, tax }).toFixed(2);
    tax.totalTaxGrandTotal = recalculateTotal({ idQuestion: 2438, tax }).toFixed(2);

    setTaxes((prevTaxes) => {
      const updatedTaxes = [...prevTaxes];
      const taxIndex = updatedTaxes.findIndex((t) => t.taxType === tax.taxType);
      if (taxIndex !== -1) updatedTaxes[taxIndex] = tax;
      return updatedTaxes;
    });
  }

  try {
  } catch (e) {
    console.log("TAX_CALCULATION - handleQuestionBlur error", e);
  }
}


async function handleRequestSerproCnpj({
  question: rootQuestion,
  data,
  questionnaire,
  setQuestionnaire,
  setFieldValue,
}) {
  try {
    questionnaire = questionnaire.map(question => {

      return question;
    })

    setQuestionnaire(questionnaire);
  } catch (e) {
    console.log('TAX_CALCULATION - handleRequestSerproCnpj - error', e)
  }
};

function mountTaxesObjects({ insurerGroup, periods }) {
  // cria array com os nomes das taxas
  const taxes = [];
  for (const questions of insurerGroup) {
    const taxNameQst = questions.find((question) => question.idQuestion === 1380);
    if (!taxNameQst.answer) continue;
    const taxNameAnswer = JSON.parse(taxNameQst.answer);
    if (taxes.some((tax) => tax.value === taxNameAnswer.value)) continue;
    taxes.push(taxNameAnswer);
  }

  // cria array de objetos com as taxas
  const taxesObjects = [];
  for (const tax of taxes) {
    const formattedPeriods = periods.map((period) => {
      return {
        insurer: period.insurer,
        idPersonInsurer: period.idPersonInsurer,
        facilityName: period.facilityName,
        facilityId: period.facilityInfo.idQuestionnaireAnswer,
        dpTaxable: period.dpTaxable,
        apTaxable: period.apTaxable,
        lineSize: period.lineSize,
        dpBrokerageGross: period.dpBrokerageGross,
        apBrokerageGross: period.apBrokerageGross,
        commercialFee: period.commercialFee,
        totalOtherFees: period.totalOtherFees,
      }
    })

    const taxObject = {
      taxType: tax.value,
      taxId: tax.id,
      periods: formattedPeriods,
    }
    taxesObjects.push(taxObject);
  }

  // obtem array de taxas
  const taxesArray = mountTaxesArray({ insurerGroup });
  // adiciona taxas ao objeto de taxas
  for (const taxObj of taxesObjects) {
    const filteredTaxes = taxesArray.filter((tax) => tax.taxName === taxObj.taxType);
    for (const period of taxObj.periods) {
      const periodTax = filteredTaxes.find((tax) => tax.facilityName === period.facilityName && tax.idPersonInsurer === period.idPersonInsurer);
      if (periodTax) {
        period.taxRate = periodTax.taxRate;
        period.rateAndBasis = periodTax.rateAndBasis;
        period.chargeType = periodTax.chargeType;
        period.dpTax = periodTax.dpTax;
        period.apTax = periodTax.apTax;
      }

      if (filteredTaxes[0].idFacility == -1) {
        period.taxRate = filteredTaxes[0].taxRate;
        period.rateAndBasis = filteredTaxes[0].rateAndBasis;
        period.chargeType = filteredTaxes[0].chargeType;
        period.dpTax = filteredTaxes[0].dpTax;
        period.apTax = filteredTaxes[0].apTax;
      }

      if (filteredTaxes[0].idPersonInsurer == -1) {
        period.taxRate = filteredTaxes[0].taxRate;
        period.rateAndBasis = filteredTaxes[0].rateAndBasis;
        period.chargeType = filteredTaxes[0].chargeType;
        period.dpTax = filteredTaxes[0].dpTax;
        period.apTax = filteredTaxes[0].apTax;
      }
    }
  }
  return taxesObjects;
}

function mountTaxesArray({ insurerGroup }) {
  const taxesArray = [];

  for (const questions of insurerGroup) {
    try {
      const taxName = JSON.parse(questions.find((question) => question.idQuestion === 1380)?.answer)?.value;
      const rateAndBasis = JSON.parse(questions.find((question) => question.idQuestion === 1382)?.answer)?.id;
      const idPersonInsurer = JSON.parse(questions.find((question) => question.idQuestion === 1378)?.answer)?.id;
      const facilityName = JSON.parse(questions.find((question) => question.idQuestion === 1379)?.answer)?.value;
      const taxRate = questions.find((question) => question.idQuestion === 1384)?.answer;
      const apTax = questions.find((questions) => questions.idQuestion === 2105)?.answer;
      const dpTax = questions.find((questions) => questions.idQuestion === 2106)?.answer;
      const chargeType = JSON.parse(questions.find((question) => question.idQuestion === 1383).answer)?.id;
      const tax = {
        taxName,
        rateAndBasis,
        idPersonInsurer,
        facilityName,
        taxRate,
        chargeType,
        apTax,
        dpTax
      }
      taxesArray.push(tax);
    } catch (e) {
      console.log("error", e)
    }
  }
  return taxesArray;
}

function cloneQuestion(baseQuestion, answer, answerJson = {}, behavior = null) {
  return {
    ...baseQuestion,
    idQuestionnaireAnswers: null,
    idQuestionnaireAnswersParent: null,
    idQuestionnaireAnswersRoot: null,
    idAnswerOption: null,
    key: null,
    answer,
    behaviorObject: behavior ? behavior : baseQuestion.behaviorObject,
    answerJson,
  };
}

function createQuestionsByTax({ taxesObject, groupQuestion }) {
  const questionIds = [2426, 2427, 2428, 2429, 2430, 2431, 2432, 2433, 2438, 2105, 2106];
  const questionsMap = Object.fromEntries(
    questionIds.map((id) => [id, groupQuestion[0].find((q) => q.idQuestion === id)])
  );
  for (const taxObj of taxesObject) {
    let questions = [];
    let dpTaxGrandTotal = 0;
    let apTaxGrandTotal = 0;
    let totalTaxGrandTotal = 0;
    for (const period of taxObj.periods) {
      // verifica se o rateAndBasis e Exempt
      if (period.rateAndBasis == 669) continue;
      const insurerData = JSON.stringify({ value: period.insurer, id: period.idPersonInsurer });
      const facilityData = JSON.stringify({ value: period.facilityName, id: period.facilityId });
      const taxNameData = JSON.stringify({ value: taxObj.taxType, id: taxObj.taxId });

      let apTaxFixed = Number(period.apTax)
      let dpTaxFixed = Number(period.dpTax)
      const chargeTypeData = period.chargeType
      const baseQuestions = [
        cloneQuestion(questionsMap[2426], insurerData, insurerData),
        cloneQuestion(questionsMap[2427], facilityData, facilityData),
        cloneQuestion(questionsMap[2428], taxNameData, taxNameData),
        cloneQuestion({ ...questionsMap[2431], fieldMask: chargeTypeData === 630 ? null : questionsMap[2431].fieldMask }, chargeTypeData === 630 ? "Fixed" : period.taxRate, null, { ...questionsMap[2431].behaviorObject, isReadOnly: chargeTypeData === 630 }),
      ];

      let { dpBasis, apBasis } = _getDpAndApBasis({ rateAndBasis: period.rateAndBasis, period });
      if (!dpBasis) dpBasis = 0;
      if (!apBasis) apBasis = 0;
      dpBasis = Number(dpBasis.toFixed(2));
      apBasis = Number(apBasis.toFixed(2));

      const dpTax = Number((period.taxRate > 0 ? dpBasis * (period.taxRate / 100) : dpTaxFixed).toFixed(2));
      const apTax = Number((period.taxRate > 0 ? apBasis * (period.taxRate / 100) : apTaxFixed).toFixed(2));

      const totalTax = Number((dpTax + apTax).toFixed(2));

      baseQuestions.push(
        cloneQuestion(questionsMap[2432], dpTax, null, { ...questionsMap[2432].behaviorObject, isReadOnly: chargeTypeData !== 630 }),
        cloneQuestion(questionsMap[2433], apTax, null, { ...questionsMap[2433].behaviorObject, isReadOnly: chargeTypeData !== 630 }),
        cloneQuestion(questionsMap[2438], totalTax),
        cloneQuestion(questionsMap[2429], dpBasis),
        cloneQuestion(questionsMap[2430], apBasis)
      );

      dpTaxGrandTotal += dpTax;
      apTaxGrandTotal += apTax;
      totalTaxGrandTotal += totalTax;

      questions.push(baseQuestions.sort((a, b) => a.sequenceQuestion - b.sequenceQuestion));
    }

    questions = sortBy(questions, function (item) {
      return [item[0].answer, item[1].answer];
    });

    Object.assign(taxObj, { groupedQuestions: questions, dpTaxGrandTotal, apTaxGrandTotal, totalTaxGrandTotal });
  }

  return taxesObject;
}

const _getDpAndApBasis = ({ rateAndBasis, period }) => {
  const basisObj = {
    dpBasis: null,
    apBasis: null,
  }
  switch (Number(rateAndBasis)) {
    case 665:
      basisObj.dpBasis = period.dpTaxable || 0;
      basisObj.apBasis = period.apTaxable || 0;
      break;
    case 666:
      basisObj.dpBasis = period.dpTaxable || 0;
      basisObj.apBasis = period.apTaxable || 0;
      break;
    case 667:
      basisObj.dpBasis = period.lineSize || 0;
      basisObj.apBasis = period.lineSize || 0;
      break;
    case 668:
      basisObj.dpBasis = period.dpBrokerageGross || 0;
      basisObj.apBasis = period.apBrokerageGross || 0;
      break;
    case 1021:
      basisObj.dpBasis = period.commercialFee || 0;
      basisObj.apBasis = period.commercialFee || 0;
      break;
    case 1022:
      basisObj.dpBasis = period.totalOtherFees || 0;
      basisObj.apBasis = period.totalOtherFees || 0;
      break;
    default:
      break
  }
  return basisObj;
}

const groupTaxesQuestions = ({ groupQuestion, taxesObject }) => {
  const taxNameIdQuestion = 2428;

  for (const taxObj of taxesObject) {
    const groupQuestions = [];
    let dpTaxGrandTotal = 0;
    let apTaxGrandTotal = 0;
    let totalTaxGrandTotal = 0;

    groupQuestion = sortBy(groupQuestion, function (item) {
      return [item[0].answer, item[1].answer];
    });

    for (const group of groupQuestion) {
      try {
        const taxName = JSON.parse(group.find((q) => q.idQuestion === taxNameIdQuestion).answer);
        if (taxName.value === taxObj.taxType) {
          groupQuestions.push(group);
          const question2431 = group.find((q) => q.idQuestion === 2431);
          const questionsToFixed = [2432, 2433, 2438, 2429, 2430]
          group.forEach(item => {
            if (questionsToFixed.includes(item.idQuestion)) {
              const valor = parseFloat(item.answer);
              if (!isNaN(valor)) {
                item.answer = valor.toFixed(2);
              }
            }
          });
          if (question2431 && question2431.answer === "Fixed") {
            question2431.behaviorObject.isReadOnly = true;
            question2431.fieldMask = null;
          } else {
            question2431.behaviorObject.isReadOnly = false;
            question2431.fieldMask = {
              type: "percentage",
              mask: "% num",
              blocks: {
                num: {
                  mask: 0,
                  scale: 5,
                  signed: false,
                  normalizeZeros: false,
                  padFractionalZeros: true,
                  thousandsSeparator: ",",
                  radix: ".",
                  mapToRadix: [".", ","],
                  min: -999999999999.99,
                  max: 100
                }
              }
            }
          }

          const dpTax = group.find((q) => q.idQuestion === 2432).answer || 0;
          const apTax = group.find((q) => q.idQuestion === 2433).answer || 0;
          const totalTax = group.find((q) => q.idQuestion === 2438).answer || 0;

          dpTaxGrandTotal += Number(dpTax);
          apTaxGrandTotal += Number(apTax);
          totalTaxGrandTotal += Number(totalTax);

        }
      } catch (e) {

      }
    }
    taxObj.groupedQuestions = groupQuestions;
    taxObj.dpTaxGrandTotal = Number(dpTaxGrandTotal);
    taxObj.apTaxGrandTotal = Number(apTaxGrandTotal);
    taxObj.totalTaxGrandTotal = Number(totalTaxGrandTotal);
  }
  return taxesObject;
}

const recalculateTax = ({
  idQuestion,
  tax,
  indexQuestions,
  value,
}) => {
  const questions = tax.groupedQuestions[indexQuestions];
  const dpBasis = idQuestion === 2429 ? value : questions.find((q) => q.idQuestion === 2429).answer;
  const apBasis = idQuestion === 2430 ? value : questions.find((q) => q.idQuestion === 2430).answer;
  const taxRate = idQuestion === 2431 ? value : questions.find((q) => q.idQuestion === 2431).answer;
  const dpTax = Number([2432, 2433].includes(idQuestion) ? questions.find((q) => q.idQuestion === 2432).answer : dpBasis * (taxRate / 100));
  const apTax = Number([2432, 2433].includes(idQuestion) ? questions.find((q) => q.idQuestion === 2433).answer : apBasis * (taxRate / 100));
  const totalTax = dpTax + apTax;

  return {
    dpBasis,
    apBasis,
    dpTax,
    apTax,
    totalTax,
  }
}

const recalculateTotal = ({ idQuestion, tax }) => {
  const total = tax.groupedQuestions.reduce((total, questions) => {
    const question = questions.find((q) => q.idQuestion === idQuestion);
    total = total + Number(question?.answer || 0)
    
    return total;
  }, 0);

  return total;
}

const events = {
  handleInitialAdjustments,
  handleQuestionChange,
  handleQuestionBlur,
  handleRequestSerproCnpj,
};

export { events };